export const ALL_FAMILY_CODE = 'all';

/**
 * Indicates the width break point for each screen size;
 */
export const MEDIA_QUERIES = {
    /** Minimum screen size width: 0rem | 0px */
    XS: 0,
    /** Small Screen size width: 34rem | 480px */
    SM: 480,
    /** Medium Screen size width: 48rem | 768px */
    MD: 768,
    /** Large Screen size width: 62rem | 992px */
    LG: 992,
    /** Extra large screen size width: 75rem | 1200px */
    XL: 1200
};

export const DEFAULT_FAMILY_CODE = 'tcb';

export const DEFAULT_POLICY_MAPPER = {
    'es-ar': 'tcb',
    'es-cl': 'tcb',
    'es-co': 'tcb',
    'es-mx': 'rc',
    'es-py': 'tcb',
    'es-uy': 'tcb',
    'pt-br': 'tcb'
};
/**
 * Object that enums the template types
 */
export const TEMPLATES_TYPES = {
    HOME: 'home',
    INSURANCE_CAR: 'insurance-car',
    INSURANCE_LOCATION: 'insurance-location',
    INSURANCE_COMPANY: 'insurance-company',
    INSURANCE_CAR_LANDING: 'insurance-car-landing'
};

export const COMPANY_PROFILE_ITEMS_MAPPER = [
    'branches_office',
    'ceo',
    'customer',
    'employees',
    'founded',
    'head_quarter',
    'insurance_claim',
    'insurance_product',
    'operating_country',
    'raiting',
    'repair_shop_partner',
    'solvency_ratio'
];

export const COVERAGES_CODE_LIST = {
    'es-ar': ['1', '27', '2', '4', '18', '3', '6'],
    'pt-br': ['1', '27', '2', '4', '18', '3', '6'],
    'es-mx': ['100', '105', '101', '108', '122', '111', '113']
};

export const BASE_COLOR_SCHEMA = '#3F4E89';

/**
 * List of ensurance that are saved on the api DB under two or more company_code,
 * and they show more than once in the insurance selector widget (PILAR III).
 */
export const INSURANCE_DUPLICATED_LIST = {
    'es-ar': [
        'laholando',
        'norte',
        'laequitativa',
        'lameridional',
        'prudenciaseguros',
        'segurosrivadavia',
        'segunda'
    ],
    'es-cl': [],
    'es-co': [],
    'es-mx': ['aseguradorapatrimonial_mx'],
    'es-py': [],
    'es-uy': []
    // 'pt-br': []
};

// Deductibles section
const CHECKMARK = '\u2714';
const MARK = 'X';

export const DEDUCTIBLES_MAP = {
    'es-ar': {
        data: {
            low: [CHECKMARK, CHECKMARK, MARK, MARK],
            moderate: [CHECKMARK, CHECKMARK, CHECKMARK, MARK],
            high: [CHECKMARK, MARK, MARK, CHECKMARK]
        },
        headers: [
            'Perfil de riesgo',
            'Responsabilidad Civil',
            'Terceros Basicos',
            'Terceros Completos',
            'Todo Riesgo'
        ]
    },
    'es-mx': {
        data: {
            low: [CHECKMARK, CHECKMARK, MARK, MARK],
            moderate: [CHECKMARK, CHECKMARK, CHECKMARK, MARK],
            high: [CHECKMARK, MARK, MARK, CHECKMARK]
        },
        headers: [
            'Perfil de riesgo',
            'Responsabilidad Civil',
            'Cobertura Limitada',
            'Cobertura Amplia',
            'Amplia Plus'
        ]
    },
    'pt-br': {
        data: {
            low: [CHECKMARK, CHECKMARK, CHECKMARK, CHECKMARK],
            moderate: [CHECKMARK, CHECKMARK, CHECKMARK, MARK],
            high: [CHECKMARK, MARK, MARK, MARK]
        },
        headers: [
            'Perfil de risco',
            'Roubo e Furto',
            'Básica',
            'Compreensiva',
            'Compreensiva Plus'
        ]
    }
};

export const ARROW_STYLE = {
    transition: 'all 0.3s ease-in',
    transform: 'rotate(180deg)'
};

export const BUTTON_FONT = { style: { fontSize: '16px', fontWeight: 700, zIndex: 1000 } };
